import { Injectable } from '@angular/core';
import { DataStoreService } from './data-store.service';
@Injectable({
  providedIn: 'root'
})
export class BasketService {
  currentBasket;
  purchase;

  constructor(
    private datastore: DataStoreService
  ) { }

  async createBasket() {
    const company = this.datastore.selectedLocation;
    this.currentBasket = await company.$post('baskets', { company_id: company.id });
    return this.currentBasket;
  }

  async getCurrentBasket() {
    const company = this.datastore.selectedLocation;
    const baseBasketResource = await company.$get('baskets', { company_id: company.id });
    const baskets = await baseBasketResource.$get('baskets');
    this.currentBasket = baskets[baskets.length - 1];
    return baskets[baskets.length - 1];
  }

  async deleteAllBaskets() {
    const company = this.datastore.selectedLocation;
    if (company) {
      if (!company.$has('baskets')) {
        return null;
      }
    }

    const baskets = await this.checkForExistingBaskets();

    if (baskets && baskets.length >= 1) {
      for (const basket of baskets) {
        new Promise(() => {
          company.$del('baskets', { basket_id: basket.id }).then(() => {
            Promise.resolve();
          });
        });
      }
    }
  }

  async checkForExistingBaskets() {
    const company = this.datastore.selectedLocation;
    if (company) {
      if (company.$has('baskets')) {
        const baseBasketResource = await company.$get('baskets', { company_id: company.id });
        const baskets = await baseBasketResource.$get('baskets');
        return baskets;
      }
    }
  }

  async addItem(service_id, duration, start, questions, counterId) {
    const company = this.datastore.selectedLocation;
    if (company) {
      if (company.$has('baskets')) {
        try {
          const item = await this.currentBasket.$post('service_items', {}, {
            service_id,
            duration,
            start,
            company_id: company.id,
            basket_id: this.currentBasket.id,
            questions,
            resource_id: counterId
          });

          // Reassign start time as response time removes Timezone data
          item.start = start;

          this.datastore.basketItems.push(item);
          return item;
        } catch (error) {
          return error;
        }
      }
    }
  }

  async getPurchase() {
    return this.purchase;
  }

  checkoutBasket(client, notifications) {
    const company = this.datastore.selectedLocation;
    if (company.$has('baskets')) {

      try {
        return this.currentBasket.$post('checkout', {}, {
          client,
          basket_id: this.currentBasket.id,
          no_notifications: notifications
        }).then((res) => {
          this.purchase = res;
          return res;
        });
      } catch (error) {
        return 'failed';
      }
    }
  }

  async delete(company, basket) {
    if (!company.$has('baskets')) return null;
    return company.$del('baskets', { basket_id: basket.id });
  }
}
